import { Label } from 'reactstrap';

import FieldInfo from '../field-info';
import SkeletonField from '../skeleton-field';

const SettingsField = ({
    id,
    label,
    required = false,
    info,
    hint,
    isFetching = false,
    children,
}) => (
    <>
        <Label for={id} className="fw-semibold mb-1">
            {label}
            {required && (
                <span className="text-danger ms-1">*</span>
            )}
            {info && (
                <FieldInfo id={`info-${id}`}>
                    {info}
                </FieldInfo>
            )}
        </Label>

        {isFetching ? (
            <SkeletonField />
        ) : children}

        {hint && (
            <small className="text-muted d-block mt-1">
                {hint}
            </small>
        )}
    </>
);

export default SettingsField;
